/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoleResponse } from './RoleResponse';
import {
    RoleResponseFromJSON,
    RoleResponseFromJSONTyped,
    RoleResponseToJSON,
    RoleResponseToJSONTyped,
} from './RoleResponse';
import type { PermissionResponse } from './PermissionResponse';
import {
    PermissionResponseFromJSON,
    PermissionResponseFromJSONTyped,
    PermissionResponseToJSON,
    PermissionResponseToJSONTyped,
} from './PermissionResponse';

/**
 * 
 * @export
 * @interface SectionDetailResponse
 */
export interface SectionDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof SectionDetailResponse
     */
    sectionCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SectionDetailResponse
     */
    sectionName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SectionDetailResponse
     */
    isActive?: boolean;
    /**
     * 
     * @type {Array<RoleResponse>}
     * @memberof SectionDetailResponse
     */
    roles?: Array<RoleResponse> | null;
    /**
     * 
     * @type {Array<PermissionResponse>}
     * @memberof SectionDetailResponse
     */
    permissions?: Array<PermissionResponse> | null;
}

/**
 * Check if a given object implements the SectionDetailResponse interface.
 */
export function instanceOfSectionDetailResponse(value: object): value is SectionDetailResponse {
    return true;
}

export function SectionDetailResponseFromJSON(json: any): SectionDetailResponse {
    return SectionDetailResponseFromJSONTyped(json, false);
}

export function SectionDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SectionDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'sectionCode': json['sectionCode'] === undefined ? undefined : json['sectionCode'] === null ? null : json['sectionCode'],
        'sectionName': json['sectionName'] === undefined ? undefined : json['sectionName'] === null ? null : json['sectionName'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'roles': json['roles'] === undefined ? undefined : json['roles'] === null ? null : ((json['roles'] as Array<any>).map(RoleResponseFromJSON)),
        'permissions': json['permissions'] === undefined ? undefined : json['permissions'] === null ? null : ((json['permissions'] as Array<any>).map(PermissionResponseFromJSON)),
    };
}

export function SectionDetailResponseToJSON(json: any): SectionDetailResponse {
    return SectionDetailResponseToJSONTyped(json, false);
}

export function SectionDetailResponseToJSONTyped(value?: SectionDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sectionCode': value['sectionCode'],
        'sectionName': value['sectionName'],
        'isActive': value['isActive'],
        'roles': value['roles'] == null ? undefined : ((value['roles'] as Array<any>).map(RoleResponseToJSON)),
        'permissions': value['permissions'] == null ? undefined : ((value['permissions'] as Array<any>).map(PermissionResponseToJSON)),
    };
}

